export default __webpack_public_path__ + "static/media/upcoming_event.aa83dc46.svg";